import * as React from 'react';

const SvgDefault = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <g>
        <path
          fill={fill}
          d="M17 7.764a6.972 6.972 0 00-2.206.36l3.845 6.247A.751.751 0 0118 15.514h-7.959A7 7 0 1017 7.764z"
        />
        <path fill={fill} d="M8.77 1.194L.88 14.014h15.778L8.77 1.194z" />
      </g>
    </svg>
  );
};

export default SvgDefault;
